import { create } from 'zustand/index'

import { LOCAL_STORAGE_KEY_SERVICE_TYPE_FILTER } from '@/utils/keys'

type ServiceTypeStore = {
  serviceType: number | null,
  setServiceType: (serviceType: number) => void,
  resetServiceType: () => void,
}

export const useServiceType = create<ServiceTypeStore>(set => ({
  serviceType: getServiceTypeFromLocalStorage(),
  setServiceType: (serviceType: number) => {
    set({ serviceType })
    setServiceTypeToLocalStorage(serviceType)
  },
  resetServiceType: () => {
    set({ serviceType: null })
    setServiceTypeToLocalStorage(null)
  },
}))

function getServiceTypeFromLocalStorage() {
  const serviceTypeFilter = localStorage.getItem(LOCAL_STORAGE_KEY_SERVICE_TYPE_FILTER)
  if (!serviceTypeFilter) {
    return null
  }

  return Number(serviceTypeFilter)
}

function setServiceTypeToLocalStorage(serviceType: number | null) {
  localStorage.removeItem(LOCAL_STORAGE_KEY_SERVICE_TYPE_FILTER)

  if (serviceType) {
    localStorage.setItem(LOCAL_STORAGE_KEY_SERVICE_TYPE_FILTER, serviceType.toString())
  }
}